module.exports = __webpack_public_path__ + "static/media/FB-Landing-Page-graphic3.7f924c29.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NYCMeetUpLanding/images/FB-Landing-Page-graphic3.png
// module id = 1558
// module chunks = 0